module.exports = __webpack_public_path__ + "static/media/1_en.3cae4b04.png";